import { Heading, VStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Logo } from '../../../../../packages/ui/components/atoms/Logo';
import { PrivacyPolicyPage } from './components/PrivacyPolicy';

function LegalPageTemplate({ title, children }: { title: string } & PropsWithChildren) {
  return (
    <VStack
      backgroundColor={'white'}
      borderLeft={'1px solid #dedede'}
      borderRight={'1px solid #dedede'}
      w={'90%'}
      maxW={'700px'}
      padding={{ base: '20px 10%', lg: '20px 40px' }}
    >
      <Logo />
      <Heading paddingBottom={'20px'} paddingTop={'20px'}>
        {title}
      </Heading>
      {children}
    </VStack>
  );
}

export function LegalPage() {
  return (
    <VStack backgroundColor={'#FAFAFA'} w={'100%'}>
      <Routes>
        <Route
          path="/politica-de-privacidade"
          element={
            <LegalPageTemplate title="Política de Privacidade">
              <PrivacyPolicyPage />
            </LegalPageTemplate>
          }
        />
        <Route
          path="/termos-de-uso"
          element={
            <LegalPageTemplate title="Termos de Uso">
              <PrivacyPolicyPage />
            </LegalPageTemplate>
          }
        />
      </Routes>
    </VStack>
  );
}
